import InfoDialogMap from "./infoDialogMap";

export default InfoDialogMap;